"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnaccFixedComponentDto {
}
exports.AnaccFixedComponentDto = AnaccFixedComponentDto;
